import { CheckBox } from "../../core/components/checkBox";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { Config } from "../../core/config/config";
import { ComponentHelper } from "../../core/util/componentHelper";
import { Helper } from "../../core/util/helper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { EntityWeeklyReportEntry } from "../weeklyReport";
import { EntityWeeklyReport } from "../weeklyReportInGrid";
import React from "react";
import ReactDOM from "react-dom";

export const OpenWeeklyReportCopyDialog = (entity: EntityWeeklyReport, entries: EntityWeeklyReportEntry[]) => {
    return new Promise<Date[]>((resolve) => {
        const targetElement = $("<div>");
        const root = ReactDOM["createRoot"](targetElement[0]);
        const props: any = {
            onOk: (dates: Date[]) => {
                resolve(dates)
            },
            onCancel: () => {
                resolve([]);
                root.unmount();
            },
            entity: entity,
            entries: entries
        }
        $("body").append(targetElement);
        root.render(<WeeklyReportCopyDialog {...props} />);
    })
}

class WeeklyReportCopyDialog extends React.Component<{
    entity: EntityWeeklyReport;
    entries: EntityWeeklyReportEntry[];
    onOk: (dates: Date[]) => void;
    onCancel: () => void;
}, {
    all: boolean;
    dates: Map<Date, boolean>
}>{
    private _factory = ComponentHelper.createFactory();
    private _dialogProps: DialogProps = {
        title: Helper.getTranslation("Standard.Kopieren"),
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    let checkedDates = this.getCheckedDates();
                    if (checkedDates.length == 0) {
                        NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.WeeklyReport.PleaseSelectEntry"));
                        return false;
                    }
                    this.props.onOk(checkedDates);
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.props.onCancel();
        },
        width: 500
    };

    constructor(props) {
        super(props);
        this.state = {
            dates: new Map<Date, boolean>(),
            all: false
        };
    }

    componentDidMount() {
        let freeDays = this.getFreeDays();
        let dates = new Map<Date, boolean>();
        for (let freeDay of freeDays) {
            dates.set(freeDay, false);
        }
        this.setState({ dates: dates });
    }

    private getFreeDays = () => {
        let notFreeDays = this.props.entries
            .map(x => x.Datum.getDate())
            .filter(function (value, index, self) {
                return index == self.indexOf(value);
            });

        let freeDays: Date[] = [];
        var currentDate = new Date(this.props.entity.Von);
        var endDate = new Date(this.props.entity.Bis);
        while (currentDate <= endDate) {
            if (!notFreeDays.includes(currentDate.getDate())) {
                freeDays.push(new Date(currentDate));
            }
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return freeDays;
    }

    private getCheckedDates = () => {
        let checkedDates: Date[] = [];
        let dates = this.state.dates;
        for (let date of dates) {
            if (date[1])
                checkedDates.push(date[0])
        }
        return checkedDates;
    }

    private getAllCheckBox = () => {
        let props = this._factory.getDefaultCheckBoxProps();
        props.field.model = "allCheckBox";
        props.field.labelAndControlCombined = true;
        props.field.name = Helper.getTranslation("Standard.Alle");
        props.value = this.state.all;
        props.onChange = (_, value) => {
            let all = !this.state.all;
            let dates = this.state.dates;
            dates.forEach((_, key, self) => {
                self.set(key, all);
            })
            this.setState({ all: all, dates: dates });
        };

        return <CheckBox {...props} />
    }

    private getCheckBox = (date: Date) => {
        let props = this._factory.getDefaultCheckBoxProps();
        props.field.model = Helper.dates.toString(date);
        props.field.labelAndControlCombined = true;
        props.field.name = kendo.toString(date, "ddd") + ", " + Helper.dates.toString(date);
        props.value = this.state.dates.get(date);
        props.onChange = (_, value) => {
            let dates = this.state.dates;
            dates.set(date, value);
            this.setState({ dates: dates });
        };

        return <CheckBox {...props} />
    }

    private getCheckBoxes = () => {
        let checkBoxes = [];
        for (let entry of this.state.dates.entries()) {
            checkBoxes.push(this.getCheckBox(entry[0]));
        }

        return checkBoxes;
    }

    render() {
        return (<>
            <Dialog {...this._dialogProps} open={true}>
                <div style={{ display: "flex", flexDirection: "column" }} >
                    <div>
                        {Helper.getTranslation("WebSMS.WeeklyReport.CopyTo") + ":"}
                    </div>
                    {this.state.dates.size > 0 ? this.getAllCheckBox() : null}
                    {this.state.dates.size > 0 ? this.getCheckBoxes() : null}
                    {this.state.dates.size == 0 ? <div style={{ color: "rgb(239, 83, 80)" }}>{Helper.getTranslation("WebSMS.WeeklyReport.NoFreeDay")}</div> : null}
                </div>
            </Dialog>
        </>)
    }
}